// extracted by mini-css-extract-plugin
module.exports = {"entryTitle":"post_entryTitle__PXNvx","entryContent":"post_entryContent__1OvO1","entryThumbnail":"post_entryThumbnail__2MwzK","date":"post_date__3hSfw","root":"post_root__1gliu"};